import { Avatar, type AvatarProps } from '@mui/material';
import { useEffect, useState } from 'react';
import { useClinicData } from '../../data/ClinicDataProvider';
import type { ClinicUser } from '../../domain/types';

function initials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toLocaleUpperCase('pt-BR');
}

export function UserAvatar({
  user,
  ...props
}: Omit<AvatarProps, 'src' | 'alt'> & { user: ClinicUser | null | undefined }) {
  const { loadProfilePhoto } = useClinicData();
  const [loadedPhoto, setLoadedPhoto] = useState({ path: '', url: '' });
  const loadedUrl = user?.photoPath === loadedPhoto.path ? loadedPhoto.url : '';

  useEffect(() => {
    let active = true;
    if (!user?.photoPath || user.photoUrl) return () => undefined;
    void loadProfilePhoto(user.photoPath)
      .then((url) => {
        if (active) setLoadedPhoto({ path: user.photoPath ?? '', url });
      })
      .catch(() => undefined);
    return () => {
      active = false;
    };
  }, [loadProfilePhoto, user?.photoPath, user?.photoUrl]);

  return (
    <Avatar
      {...props}
      alt={user ? `Foto de ${user.displayName}` : 'Foto de perfil'}
      src={user?.photoUrl || loadedUrl || undefined}
      sx={{ bgcolor: user?.avatarColor, ...props.sx }}
    >
      {user ? initials(user.displayName) : ''}
    </Avatar>
  );
}
